import { useContext } from "react"
import { DashboardContext } from '../pages/Dashboard/Dashboard'

export default function useDashboardState() {
    return useContext(DashboardContext)
}